<template>
  <div class="task">
    <i class="task__icon" :class="iconName"></i>

    <div class="task__items">
      <h6>
        {{ header }}
      </h6>

      <div v-if="date || status" class="task__items__infoMobile">
        <span>{{ date }}</span>
        <span>{{ status }}</span>
      </div>

      <div class="task__items__buttons">
        <button
          v-for="(button, index) in buttons"
          :key="index"
          class="btn btn-sm"
          :class="{
            'btn-primary': button.type === 'primary',
            'btn-outline-secondary': button.type === 'secondary',
          }"
          @click="button.action && emit(button)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>

    <div v-if="date || status" class="task__info">
      <span>{{ date }}</span>
      <span>{{ status }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Task',
  props: {
    iconName: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    buttons: {
      type: Array,
      required: false,
    },
  },
  methods: {
    emit(button) {
      this.$emit('click', {
        action: button.action,
        externalUrl: button.externalUrl,
        params: button.params,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.task {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border: 1px solid $gray-200;
  border-radius: $border-radius;
  padding: 1.5rem;
  height: 100%;
}
.task__icon {
  display: none;
}
.task__items {
  display: flex;
  flex-direction: column;
  gap: 0.8rem 0rem;
}
.task__items__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem 0;
}
.task__items__buttons button {
  width: 200px;
}
.task__info {
  display: none;
}
.task__items__infoMobile {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media screen and (min-width: 620px) {
  .task {
    display: grid;
    grid-template-columns: 90px 1fr 1fr;
    align-items: center;
    background: white;
    border: 1px solid $gray-200;
    border-radius: $border-radius;
    padding: 1.5rem;
  }
  .task__icon {
    display: initial;
    font-size: 1.8rem;
  }
  .task__items {
    display: block;
  }
  .task__items__buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .task__items__buttons button {
    width: initial;
  }
  .task__info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .task__items__infoMobile {
    display: none;
  }
}
</style>
